module.exports = __webpack_public_path__ + "static/media/no_map_small_version.11dd7504.svg";